import khadraPic from "@/public/images/artists/khadra.png";
import { Artist } from "@/types/types";

export const khadra = {
  id: "288",
  name: "Khadra",
  image: khadraPic,
  description: `Khadra has a soulful voice with weight and attitude, able to sit low and smooth or open up into big, commanding belts.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fkhadra-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "Mature", "Soul", "RnB", "Dance", "Funk"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "Mid",
      },
      specific: {
        low: 55,
        high: 68,
      },
      sweetSpot: 60,
    },
  },
} as const satisfies Artist;
